import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 80%;
  margin: auto;
  margin-top: 10px;
`;

export const Title = styled.h1`
  color: #7aeaa7;
  font-size: 2rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 30px;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;

  gap: 2rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const PanelSection = styled.div`
  flex: 1;
  position: relative;
`;

export const PanelTitle = styled.h2`
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 1.25rem;
`;

export const PanelContent = styled.div`
  background-color: #171a3b;
  border: 1px solid #494c6a;
  border-radius: 0.5rem;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  position: relative;
`;

export const PremisesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const PremisesItem = styled.div`
  border-bottom: 1px solid #2e324d;
  color: #ffffff;
  padding-bottom: 2rem;
  display: flex;
  gap: 1.25rem;
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const PremisesText = styled.span`
  color: #63678c;
`;

export const Select = styled.select`
  padding: 0.5rem;
  background-color: transparent;
  border: none;
  border-radius: 0.5rem;
  outline: none;
  color: #fff;

  &:focus,
  &:hover {
    outline: none;
  }
`;

export const ServiceItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-bottom: 1px solid #2e324d;
  color: white;
  padding-bottom: 2rem;
`;

export const ServiceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ServiceDetails = styled.div`
  display: grid;
  gap: 0.5rem;
`;

export const ServiceDescription = styled.p`
  color: #63678c;
  font-size: 0.75rem;
  max-width: 250px;
  word-break: break-word;
`;

export const TotalCost = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #171a3b;
  border: 1px solid #494c6a;
  border-radius: 0.5rem;
  padding: 2.5rem;
  color: white;
  height: fit-content;
  position: relative;
`;

export const TotalCostText = styled.div``;

export const TotalCostAmount = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  span {
    font-size: 1.25rem;
  }
`;

export const CountButton = styled.button`
  border: 1px solid #2e324d;
  padding: 0.25rem 1.25rem;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #d1d5db;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const CountButtonWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;
